import React from 'react';

const AdminPanelProductTable = ({ 
  productMappings, 
  setProductMappings, 
  handleSaveProductMapping 
}) => {
  const handleFieldChange = (id, field, value) => {
    const newMappings = productMappings.map(m => 
      m.id === id ? {...m, [field]: value} : m
    );
    setProductMappings(newMappings);
  };

  const handleBlur = (mapping) => {
    handleSaveProductMapping(mapping);
  };

  return (
    <div className="reaction-card">
      <div className="flex items-center mb-6">
        <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-500 rounded-xl flex items-center justify-center mr-4">
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
          </svg>
        </div>
        <div>
          <h2 className="text-2xl font-bold text-white">Product Mappings & Pricing</h2>
          <p className="text-gray-400 text-sm mt-1">Configure vendor IDs and public pricing for all reactions</p>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-slate-700">
              <th className="text-left py-3 px-4 text-gray-300 font-semibold">Reaction</th>
              <th className="text-left py-3 px-4 text-gray-300 font-semibold">Emoji</th>
              <th className="text-center py-3 px-4 text-gray-300 font-semibold">Boostlegends ID</th>
              <th className="text-center py-3 px-4 text-gray-300 font-semibold">Dexmoji ID</th>
              <th className="text-center py-3 px-4 text-gray-300 font-semibold">Active Vendor</th>
              <th className="text-center py-3 px-4 text-gray-300 font-semibold">Price (USD)</th>
            </tr>
          </thead>
          <tbody>
            {productMappings.map((mapping) => (
              <tr key={mapping.id} className="border-b border-slate-800 hover:bg-slate-800/30">
                <td className="py-4 px-4">
                  <div className="font-semibold text-white">{mapping.name}</div>
                  <div className="text-xs text-gray-400">ID: {mapping.id}</div>
                </td>
                <td className="py-4 px-4 text-2xl">{mapping.emoji}</td>
                <td className="py-4 px-4">
                  <input
                    type="number"
                    value={mapping.boostlegends_service_id || ''}
                    onChange={(e) => handleFieldChange(mapping.id, 'boostlegends_service_id', parseInt(e.target.value) || 0)}
                    onBlur={() => handleBlur(mapping)}
                    className="w-24 px-3 py-2 bg-slate-800 border border-slate-600 rounded-lg text-white text-center focus:ring-2 focus:ring-purple-500"
                    placeholder="0"
                  />
                </td>
                <td className="py-4 px-4">
                  <input
                    type="number"
                    value={mapping.dexmoji_service_id || ''}
                    onChange={(e) => handleFieldChange(mapping.id, 'dexmoji_service_id', parseInt(e.target.value) || 0)}
                    onBlur={() => handleBlur(mapping)}
                    className="w-24 px-3 py-2 bg-slate-800 border border-slate-600 rounded-lg text-white text-center focus:ring-2 focus:ring-teal-500"
                    placeholder="0"
                  />
                </td>
                <td className="py-4 px-4">
                  <select
                    value={mapping.active_vendor || 'boostlegends'}
                    onChange={(e) => handleFieldChange(mapping.id, 'active_vendor', e.target.value)}
                    onBlur={() => handleBlur(mapping)}
                    className="px-4 py-2 bg-slate-800 border border-slate-600 rounded-lg text-white text-center focus:ring-2 focus:ring-blue-500 cursor-pointer"
                  >
                    <option value="boostlegends">Boostlegends</option>
                    <option value="dexmoji">Dexmoji</option>
                  </select>
                </td>
                <td className="py-4 px-4">
                  <div className="flex items-center justify-center gap-2">
                    <span className="text-gray-400">$</span>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      value={mapping.price_usd || ''}
                      onChange={(e) => handleFieldChange(mapping.id, 'price_usd', parseFloat(e.target.value) || 0)}
                      onBlur={() => handleBlur(mapping)}
                      className="w-20 px-3 py-2 bg-slate-800 border border-slate-600 rounded-lg text-white text-center focus:ring-2 focus:ring-orange-500"
                      placeholder="0.05"
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-4 p-4 bg-blue-500/10 rounded-lg border border-blue-500/20">
        <div className="flex items-start gap-3">
          <svg className="w-5 h-5 text-blue-400 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div className="text-sm text-gray-300">
            <p className="font-semibold mb-1">💡 Tips:</p>
            <ul className="space-y-1 text-gray-400">
              <li>• <strong>Vendor IDs</strong>: Used for auto-fulfillment integrations with respective vendors</li>
              <li>• <strong>Active Vendor</strong>: Orders will be routed to the selected vendor for auto-fulfillment</li>
              <li>• <strong>Price (USD)</strong>: Displayed to users on the website ($0.05 per reaction)</li>
              <li>• <strong>Auto-save</strong>: Changes saved automatically when you leave a field</li>
              <li>• Set vendor ID to 0 to disable that vendor for a reaction</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanelProductTable;
